export default __webpack_public_path__ + "static/media/payment-moritz.0d82eb2d.svg";